import { useState } from 'react'
import { Box, MenuItem, TextField, Typography } from '@mui/material'

import { useListProjectsQuery } from '@/apis/projectsApi'
import { useProjectId } from '@/hooks/useReportArgs'

import { IntegrationsCard } from './IntegrationsCard'
import { ManagementKeysCard } from './ManagementKeysCard'
import { ProjectKeysCard } from './ProjectKeysCard'

/** API keys: connected integrations and v2 project keys (pk / sk) per project, then management keys. */
export function ApiKeysPage() {
    const { data: projects = [] } = useListProjectsQuery()
    const selected = useProjectId()
    const [picked, setPicked] = useState('')
    const projectId = picked || selected || projects[0]?.id || ''

    return (
        <Box sx={{ p: 3 }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 2,
                    mb: 3,
                }}
            >
                <Typography variant="h5">API Keys</Typography>
                <TextField
                    size="small"
                    select
                    label="Project"
                    value={projects.some(p => p.id === projectId) ? projectId : ''}
                    onChange={e => setPicked(e.target.value)}
                    sx={{ minWidth: 240 }}
                >
                    {projects.map(p => (
                        <MenuItem key={p.id} value={p.id}>
                            {p.name}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>
            <IntegrationsCard projectId={projectId} />
            <ProjectKeysCard projectId={projectId} />
            <ManagementKeysCard />
        </Box>
    )
}
